import React from "react";
import { View } from "@react-pdf/renderer";

const DocumentDetailTable = ({ children }: { children: React.ReactNode }) => (
  <View>
    {children}
    {/* 헤더 */}
    {/* <View style={headerStyle}>
      {columns.map((col) => (
        <View style={headerCellStyle} key={col}>
          <Text>{col}</Text>
        </View>
      ))}
    </View> */}

    {/* 데이터 */}
    {/* {data.map((row, ridx) => (
      <View
        style={{
          ...rowStyle,
          borderBottom:
            ridx === data.length - 1 ? "none" : rowStyle.borderBottom,
        }}
        key={ridx}
      >
        {row.map((cell, cidx) => (
          <View style={cellStyle} key={cidx}>
            <Text>{cell}</Text>
          </View>
        ))}
      </View>
    ))} */}
  </View>
);

export default DocumentDetailTable;
